import { CodeListItemWire } from 'app/area/import-mappings/types';
import { CodeListItem, ImportMappingType } from './types-store';

export const mapListToStore = (
  codetableId: number,
  codeItems: CodeListItemWire[]
): CodeListItem[] => (codeItems
  ?.map(item => ({
    codetableId,
    id: item.code && item.code.v,
    description: item.code && item.code.d,
    disabled: item?.disabled,
    childrenCount: item.descendantCount || 0,
    importMapping: item.importMapping.map(mapping => {
      return {
        importNumber: mapping.importNumber,
        externalValue: mapping.externalValue,
        existingExternalValue: mapping.externalValue,
        type: ImportMappingType.Init
      };
    })
  })) || [] as CodeListItem[]);
